import React, { memo, useState } from 'react'
import { css } from 'styled-components'

import axios from 'axios'
import * as queryString from 'query-string'

import { Flex, Box } from '../../components/FlexBox'
import H1 from '../../components/H1'
import Lightbox from '../../components/Lightbox'
import Text from '../../components/Text'
import Modal from '../../components/StyledModal'
import { CloseIcon, ImageIcon } from '../../components/Icons'
import CircularProgress from '../../components/CircularProgress'

import { useQuery } from '../../hooks/useApollo'
import { LIST_EXAMS } from './Gqls'

import BASE_API from '../../constants/baseApi'
import AUTH_TOKEN from '../../constants/authToken'

const Exams = memo(({ navigate, data }) => {

  const { patient, folder } = data
  const exams = folder.results
  
  const [examImages, setExamImages] = useState([])
  const [exam, setExam] = useState()

  // exam

  const handleExamClick = item => {
    setExamImages(item.exams[0].medias.map(item => item.image))
    setExam(item)
  }

  return (
    <>

      <Box p={4}>
        <Box mb={2} cursor='pointer' onClick={() => navigate(`/pacientes/${patient.id}`)}>← Voltar</Box>

        <Box mb={4}>
          <H1>{patient.name} - Exames</H1>
        </Box>


        {exams.map((item, index) => (
          <Flex ai='center' key={index} onClick={() => handleExamClick(item)} cursor='pointer' p={3} style={{borderBottom: '1px solid lightgrey'}}>
            <Box color='hsla(199, 75%, 57%, 1)' mr={3} css={{lineHeight: 0}}>
              <ImageIcon height={30} />
            </Box>
            <Box>
              {item.exams[0].name} - {item.date}
            </Box>
            <Box ml={3}>
              <Text fs={12}>{item.exams[0].description}</Text>
            </Box>
            <Box flex={1} ta='right'>
              {/*<Box mx={2} css={css`background-color: hsla(199,75%,57%,1); color: white; font-size: 12px; padding: 5px 8px; display: inline-block; line-height: 13px; font-weight: 700; border-radius: 12px;`}>Recebido</Box>
              {item.exams[0].visualized != null && item.exams[0].visualized > 0 ?
                <Box mx={2} css={css`background-color: #6CC164; color: white; font-size: 12px; padding: 5px 8px; display: inline-block; line-height: 13px; font-weight: 700; border-radius: 12px;`}>Visualizado</Box> : ''
              }*/}
            </Box>
          </Flex>
        ))}

      </Box>

      {(examImages.length > 0) &&
        <Modal
          onCloseCompleted={() => { setExamImages([]) }}
          render={
            ({onRequestClose}) => (
              <Flex fd='column' h='100%'>
                <Box position='relative' h={64}>
                  <Box position='absolute' cursor='pointer' lh='0' top={16} right={16} onClick={onRequestClose}><CloseIcon /></Box>
                  <Box p={3} ta='center'><Text secondary large>Exame</Text></Box>
                </Box>
                <Box p={4} overflow='auto'>
                  <Box>
                    {/* <img src={examImageUrl} style={{width: '100%'}} /> */}

                    {/* <Flex mb={4} jc='center'>
                      <Box mx={2} css={css`background-color: hsla(199,75%,57%,1); color: white; font-size: 10px; text-transform: uppercase; padding: 5px 8px; display: inline-block; line-height: 13px; font-weight: 700; border-radius: 10px;`}>Recebido</Box>
                      {exam.exams[0].visualized && exam.exams[0].visualized > 0 &&
                        <Box mx={2} css={css`background-color: hsla(199,75%,57%,1); color: white; font-size: 10px; text-transform: uppercase; padding: 5px 8px; display: inline-block; line-height: 13px; font-weight: 700; border-radius: 10px;`}>Visualizado</Box>
                      }
                    </Flex> */}

                    <Lightbox color='hsla(211,20%,43%,1)' images={examImages} />
                  </Box>
                </Box>
              </Flex>
            )
          }
        />
      }

    </>
  )
})

export default memo(props => {
  const { data, error, loading } = useQuery(LIST_EXAMS, { variables: { id: props.id } })
  if (error) return `Erro! ${error.message}`
  if (!data || loading) return <CircularProgress />
  return <Exams {...props} data={data} />
})
